import { AfterViewInit, Component, ComponentRef, OnInit, ViewChild } from '@angular/core';

import { JqWidgets } from 'src/app/utils/jqWidgets';
import { AppComponent } from 'src/app/app.component';
import { CustomForms } from '../../../forms/custom-forms';
import { environment } from 'src/environments/environment';
import { MainComponent } from 'src/app/components/main/main.component';

import { jqxGridComponent } from 'jqwidgets-ng/jqxgrid';
import { jqxWindowComponent } from 'jqwidgets-ng/jqxwindow';

import { SsoService } from 'src/app/services/sso/sso.service';
import { ZonesService } from 'src/app/services/zones/zones.service';
import { RangosService } from 'src/app/services/ciudadanos/tarjetas/rangos.service';
import { TarjetasService } from 'src/app/services/ciudadanos/tarjetas/tarjetas.service';

import { ZonaModel } from 'src/app/services/zones/models/zona.model';
import { RangoModel } from 'src/app/services/ciudadanos/models/rango.model';
import { TarjetaModel } from 'src/app/services/ciudadanos/models/tarjeta.model';

import { TabRangosComponent } from '../tab-rangos.component';
import { TarjetasCiudadanosComponent } from '../../tarjetas-ciudadanos.component';
import { jqxInputComponent } from 'jqwidgets-ng/jqxinput';

@Component({
  selector: 'app-form-rango',
  templateUrl: './form-rango.component.html',
  styleUrls: ['./form-rango.component.css']
})
export class FormRangoComponent extends CustomForms implements OnInit, AfterViewInit {
  @ViewChild('formWindow') public formWindow: jqxWindowComponent;
  @ViewChild('inputTarjetaIni') public inputTarjetaIni: jqxInputComponent;
  @ViewChild('inputTotalTarjetas') public inputTotalTarjetas: jqxInputComponent;

  public totalTarjetas = 1;

  public isLoading: boolean = false;

  private componentRef = null;
  public environment = environment;
  public static _this: FormRangoComponent;
  public langGrid = JqWidgets.getLocalization('es');

  public rango: RangoModel = new RangoModel();
  public tarjetasSinRango: TarjetaModel[] = [];
  public tarjetas: TarjetaModel[] = [];

  public translate(text: string): string {
    return AppComponent.translate(text);
  }

  public constructor(
    private ssoService: SsoService,
    private zonesService: ZonesService,
    private rangosService: RangosService,
    private tarjetasService: TarjetasService
  ) {
    super();
    FormRangoComponent._this = this;
  }

  public init(componentRef: ComponentRef<FormRangoComponent>, params: object): void{
    this.componentRef = componentRef;
    this.rango = params['rango'] ? params['rango'] : new RangoModel();
    this.tarjetasSinRango = params['tarjetasSinRango'] ? params['tarjetasSinRango'] : [];
    this.totalTarjetas = this.rango.idTarjetaFinal - this.rango.idTarjetaInicial + 1
  }

  public ngOnInit(): void {
    this.langGrid = JqWidgets.getLocalization(this.ssoService.getTicket().Usuario.Idioma.Codigo.substring(0, 2));

    /*
     En caso de que se este editando el rango
     obtengo todas las tarjetas y
     concateno las que estan sin rango
     con las asignadas al rango que se esta editando
    */
    if(this.rango.id > 0) {
      this.getTarjetas();
    }else {
      this.includeTarjetasSinRango();
    }

    this.getZones();
  }

  public ngAfterViewInit(): void {
    this.addCustomForm(this.formWindow);
  }

  public onClose(): void {
    if(this.componentRef) {
      this.componentRef.destroy();
    }
    TarjetasCiudadanosComponent?._this?.window?.expandWindow();
  }

  public closeWindow(): void {
    this.formWindow.close();
  }

  public async getTarjetas(): Promise<void> {
    this.tarjetasService.getTarjetas().then(
      (result) => {
        this.tarjetas = result.sort((a, b) => (a.idTarjeta < b.idTarjeta ? -1 : 1));

        const startId = this.tarjetas.findIndex(tarj => tarj.idTarjeta === this.rango.idTarjetaInicial);
        const endId = this.tarjetas.findIndex(tarj => tarj.idTarjeta === this.rango.idTarjetaFinal);

        this.tarjetas = this.tarjetas.slice(startId, (endId + 1));

        this.includeTarjetasSinRango();
      }
    )
  }

  public includeTarjetasSinRango(): void {
    if (this.tarjetas.length > 0) {
      this.tarjetasSinRango = this.tarjetasSinRango.concat(this.tarjetas);
    }
    this.tarjetasSinRango = this.tarjetasSinRango.sort((a, b) => (a.idTarjeta < b.idTarjeta ? -1 : 1));
    if (this.rango.id === 0) {
      this.rango.idTarjetaInicial = this.tarjetasSinRango[0]?.idTarjeta;
      this.rango.idTarjetaFinal = this.tarjetasSinRango[0]?.idTarjeta;
    }
  }

  public async onGuardar(): Promise<void> {
    this.isLoading = true;

    this.rangosService.createRango(this.rango).then(
      (result) => {
        if(result) {
          this.rango = result;
          MainComponent.getInstance().showInfo(
            'ATENCION',
            'Registro_almacenado',
            2000
          );

          const selectedZonas = this.zonasToAsign;

          if(selectedZonas.length !== 0) {
            const zonasToAsociate = [];
            selectedZonas.forEach(zona => {
              zonasToAsociate.push({
                "idZona": zona.Id,
                "enviar": false
              });
            });
            FormRangoComponent._this.rangosService.asociateRangoZona(FormRangoComponent._this.rango.id, zonasToAsociate).then(
              () => {
              }
            )
          }

          FormRangoComponent._this.formWindow.close();
          TabRangosComponent._this.getRangos();
        }
      }
    )
    this.isLoading = false;
  }

  public changeTarjetaInicial(value: string): void {
    const numValue = Number.parseInt(value);

    this.rango.idTarjetaInicial = numValue;
    this.calcFin();
  }

  public changeTotalTarjetas(value: string): void {
    const numValue = Number.parseInt(value);

    this.totalTarjetas = numValue;
    this.calcFin()
  }

  public calcFin(): void {
    this.rango.idTarjetaFinal = this.totalTarjetas + this.rango.idTarjetaInicial - 1;
  }

  public tarjetaCanBeAssigned(idTarjeta: number): number {
    const index = this.tarjetasSinRango.findIndex(tarjeta => tarjeta.id === idTarjeta);

    return index;
  }

  public setLista(checked: boolean, lista: string): void {
    this.rango[`lista${lista}`] = checked;
  }

  /* LISTADO ZONAS */
  public zonas: ZonaModel[] = [];
  public zonasToAsign: ZonaModel[] = [];

  @ViewChild('gridZonas') public gridZonas: jqxGridComponent;
  @ViewChild('gridZonasToAsign') public gridZonasToAsign: jqxGridComponent;

  public columnsZonas = [
    { text: 'Id', columntype: 'textbox', datafield: 'id', hidden: true },
    { text: AppComponent.translate('Nombre'), columntype: 'textbox', filtertype: 'textbox', datafield: 'nombre', width: 140, },
    { text: AppComponent.translate('Tipo'), columntype: 'textbox', datafield: 'tipo', width: 60, },
  ];

  public sourceZonas = {
    datatype: 'json',
    datafields: [
      { name: 'id', type: 'number', map: 'Id' },
      { name: 'nombre', type: 'string', map: 'Nombre' },
      { name: 'tipo', type: 'string', map: 'TipoNombre' },
    ],
    localdata: [],
  };
  public adapterZona = new jqx.dataAdapter(this.sourceZonas);

  public sourceZonasToAsign = {
    datatype: 'json',
    datafields: [
      { name: 'id', type: 'number', map: 'Id' },
      { name: 'nombre', type: 'string', map: 'Nombre' },
      { name: 'tipo', type: 'string', map: 'TipoNombre' },
    ],
    localdata: [],
  };
  public adapterZonaToAsign = new jqx.dataAdapter(this.sourceZonasToAsign);

  public async getZones(): Promise<void> {
    this.isLoading = true;
    await this.zonesService.getZonas().then(
      res => {
        this.zonas = res;
        this.zonas.sort((a, b) => a.Nombre < b.Nombre ? -1 : 1);

        if(this.rango && this.rango.zonas && this.rango.zonas.length !== 0) {
          this.rango.zonas.forEach(zona => {
              zona.Id = zona.id;
              zona.Nombre = zona.nombre;

              this.zonas.splice(this.zonas.findIndex(z => z.Id === zona.Id), 1);
              this.zonasToAsign.push(zona);
            }
          )
        }

        this.sourceZonas.localdata = this.zonas;
        this.gridZonas.updatebounddata('data');

        this.sourceZonasToAsign.localdata = this.zonasToAsign;
        this.gridZonasToAsign.updatebounddata('data');
      }
    );
    this.isLoading = false;
  }

  public associateZonaTarjeta(): void {
    const id = this.gridZonas.getrowdata(this.gridZonas.getselectedrowindex()).id;
    const zona = this.zonas.find(zona => zona.Id == id);

    this.zonasToAsign.push(zona);
    this.zonas.splice(this.zonas.findIndex(z => z.Id === id), 1);

    this.zonas.sort((a, b) => a.Nombre < b.Nombre ? -1 : 1);

    this.sourceZonas.localdata = this.zonas;
    this.gridZonas.updatebounddata();

    this.zonasToAsign.sort((a, b) => a.Nombre < b.Nombre ? -1 : 1);

    this.sourceZonasToAsign.localdata = this.zonasToAsign;
    this.gridZonasToAsign.updatebounddata();
  }

  public disassociateZonaTarjeta(): void {
    const id = this.gridZonasToAsign.getrowdata(this.gridZonasToAsign.getselectedrowindex()).id;
    const zona = this.zonasToAsign.find(zona => zona.Id == id);

    this.zonas.push(zona);
    this.zonasToAsign.splice(this.zonasToAsign.findIndex(z => z.Id === id), 1);

    this.zonas.sort((a, b) => a.Nombre < b.Nombre ? -1 : 1);

    this.sourceZonas.localdata = this.zonas;
    this.gridZonas.updatebounddata();

    this.zonasToAsign.sort((a, b) => a.Nombre < b.Nombre ? -1 : 1);

    this.sourceZonasToAsign.localdata = this.zonasToAsign;
    this.gridZonasToAsign.updatebounddata();
  }
}
